import { Heading1 } from '@components/atoms/Typography';
import RichTextWrapper from '@components/molecules/RichTextWrapper';
import { customLink, linkResolver } from '@lib/data/prismic/helpers';
import { PrismicClient } from '@lib/services/prismic';
import Section from 'components/atoms/Section';
import PageContainer from 'components/molecules/PageContainer';
import { GetStaticProps } from 'next';
import { RichText } from 'prismic-reactjs';
import styled from 'styled-components';
import { PrivacyDoc } from 'types/frontEndTypes';

interface Props {
  preview?: boolean;
  doc: PrivacyDoc;
}

const Container = styled.div`
  box-sizing: border-box;
  padding-left: 20px;
  padding-right: 20px;
  margin-top: 50px;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;

  @media (min-width: 768px) {
    max-width: 900px;
  }
`;

const Privacy = ({ doc, preview }: Props) => (
  <PageContainer
    title={doc.data.meta_title}
    metaDescription={doc.data.meta_description}
    preview={preview}
  >
    <Section>
      <Container className="container container--spaced-default container--text">
        <RichTextWrapper>
          <Heading1>{doc.data.title}</Heading1>
          <RichText
            render={doc.data.content}
            linkResolver={linkResolver}
            serializeHyperlink={customLink}
          />
        </RichTextWrapper>
      </Container>
    </Section>
  </PageContainer>
);

export const getStaticProps: GetStaticProps<Props> = async ({
  preview = false,
  previewData,
}) => {
  const doc = (await PrismicClient.getSingle(
    'privacy_policy',
    previewData as Record<string, any>,
  )) as PrivacyDoc;

  return {
    props: {
      preview,
      doc,
    },
    revalidate: 3600,
  };
};

export default Privacy;
